import AntMessage from 'antd/lib/message';

export const Message = AntMessage;
